import { useSearchSuggestionsUpdateRecentSearchesQueries } from "@faire/deprecated-retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/useSearchSuggestionsInvalidateRecentSearches";
import { useMutation as useDeleteRecentSearchMutation } from "@faire/web-api--source/endpoints/www/api/v2/search/suggestions/recent-query/query/delete-hooks";
import { logError } from "@faire/web/common/logging";
import { createToast } from "@faire/web/slate/Toast/Toast";
import { useCallback } from "react";

export const useDeleteRecentSearch = () => {
  const onDeleteRecentSearch =
    useSearchSuggestionsUpdateRecentSearchesQueries("delete");

  const { mutate } = useDeleteRecentSearchMutation({
    onSuccess: (_, [query]) => {
      onDeleteRecentSearch(query);
    },
    onError: (error) => {
      logError(error);
      createToast(error.message, {
        variant: "destructive",
        timeout: "long",
      });
    },
  });

  return useCallback(
    (query: string) => {
      mutate([encodeURIComponent(query)]);
    },
    [mutate]
  );
};
